module.exports = __webpack_public_path__ + "img/ics_o_min_circle.f7413bec.svg";